import * as _ from 'lodash'
import * as React from 'react'

export interface ISectionProps extends React.HTMLAttributes<HTMLElement> {
  active?: boolean
  disabled?: boolean
}

/**
 * Factory method to create generic <section> element
 * with className(s)
 * @param className
 */
export const sectionFactory = (className = '') => {
  return (props: ISectionProps) => {
    const classes = [className]
    const modifiedProps = _.clone(props) as ISectionProps

    if (modifiedProps.className) {
      classes.push(modifiedProps.className)
    }

    if (modifiedProps.active) {
      classes.push('active')
    }

    if (modifiedProps.disabled) {
      classes.push('disabled')
    }

    delete modifiedProps.disabled
    delete modifiedProps.active

    modifiedProps.className = classes.join(' ')

    return (
      <section {...modifiedProps}>
        {props.children}
      </section>
    )
  }
}
